import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import VideoSelfieWithBiometricsLink from 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoSelfieWithBiometricsLink/VideoSelfieWithBiometricsLink';
import { useIdentityView } from 'routes/formsView/IdentityVerificationViews/IdentityView/contexts/IdentityViewContext/IdentityViewContext';
import VideoselfieWithoutBiometricsLink from 'components/newIdentifyMethods/video/VideoSelfieBiometricsChoice/VideoselfieWithoutBiometricsLink/VideoSelfieWithoutBiometricsLink';
import { IdentificationNotBiometricModal } from 'components/newAccountSteps/profileSteps/ProfileStep5/Modals/IdentificationNotBiometricModal/IdentificationNotBiometricModal';
import { useModal } from 'hooks/useModal';
import {
    doTaggingBiometricsChoiceLinkClick,
    doTaggingOnBiometricModalCancel,
    doTaggingOnBiometricModalConfirm,
    doTaggingOnBiometricModalOpen,
    doTagPage,
} from '../tagging';

const VideoSelfieBiometricsChoice = ({ isVideoSelfieSelected, isBiometricDecisionActive, userProfile }) => {
    const { isSelectedVideoselfieWithBiometrics, setIsSelectedVideoselfieWithBiometrics } = useIdentityView();
    const { isOpen, toggleModal } = useModal();

    useEffect(() => {
        !isSelectedVideoselfieWithBiometrics && doTagPage(userProfile, true);
    }, [isSelectedVideoselfieWithBiometrics]);

    useEffect(() => {
        isOpen && doTaggingOnBiometricModalOpen();
    }, [isOpen]);

    if (!isBiometricDecisionActive || !isVideoSelfieSelected) return null;

    if (isSelectedVideoselfieWithBiometrics) {
        const handleLinkClick = () => {
            doTaggingBiometricsChoiceLinkClick(false);
            toggleModal();
        };

        const handleConfirm = () => {
            setIsSelectedVideoselfieWithBiometrics(false);
            doTaggingOnBiometricModalConfirm();
            toggleModal();
        };

        const handleCancel = isCrossPressed => {
            doTaggingOnBiometricModalCancel(isCrossPressed.isCross);
            toggleModal();
        };

        return (
            <>
                <VideoselfieWithoutBiometricsLink onClick={handleLinkClick} />
                <IdentificationNotBiometricModal showModal={isOpen} onConfirm={handleConfirm} onCancel={handleCancel} />
            </>
        );
    }

    return (
        <VideoSelfieWithBiometricsLink
            onClick={() => {
                doTaggingBiometricsChoiceLinkClick(true);
                setIsSelectedVideoselfieWithBiometrics(true);
            }}
        />
    );
};

export default connect(state => ({
    userProfile: state.userProfile,
}))(VideoSelfieBiometricsChoice);
